import React, { useState } from 'react';
import {
  Box,
  Button
} from '@material-ui/core';

import VendorDetails from 'components/Vendors/VendorDetails';
import VendorsTable from 'components/Vendors/VendorsTable';

const VendorListResults = (props) => {
  
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({});

  const addVendor = () => {
    setOpen(true);
    setUpdate(false);
    setUpdateInfo({});
  };

  const updateVendor = () => {
    setOpen(true);
    setUpdate(true);
  };

  const cancelAddUpdate = () => {
    setOpen(false);
    setUpdate(false);
    setUpdateInfo({});
  };

  const createVendorDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.vendor;
    let vendorNum;
    length < 100 ? 
      vendorNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : vendorNum = length
    return("VEN-" + vendorNum);
  };

  return (
    <Box>
      { !open ?
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      > 
        <Button
          color="primary"
          variant="contained"
          onClick={addVendor}
        >
          Add Vendor
        </Button>
      </Box> : null }
      <Box sx={{ mt: 3 }}>
        { open ?
          ( update ?
            <VendorDetails
              update={update}
              vendorInfo={updateInfo}
              cancelAddUpdate={cancelAddUpdate}
            /> :
            <VendorDetails
              activeUserId={props.activeUserId}
              update={update}
              vendorInfo={{
                displayId: createVendorDisplayId(),
                name: "",
                phone: "",
                trn: ""
              }}
              cancelAddUpdate={cancelAddUpdate}
            /> 
          ) :
          <VendorsTable
            vendors={props.vendors}
            updateVendor={updateVendor}
            setUpdateInfo={setUpdateInfo}
          />
        }
      </Box>
    </Box>
  )
};

export default VendorListResults;
